import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Button } from '../Button/ButtonElements';
import Dropdown from '../Navbar/Dropdown';
import MenuList from '../Navbar/Menu';
import Navbar from '../Navbar/Navbar';
import './Slider.css';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi';
import {useParams} from "react-router-dom";
import {collection, doc, getDoc, getDocs} from "firebase/firestore";
import {db} from "../../firebase.config";
import {ClipLoader} from "react-spinners";

const Background = styled.div`
  width: 100%;
  overflow-x: hidden;
  //padding-top: 50px;
  @media screen and (max-width: 500px) {
    //padding-top: 50px;
  }
`;
const WrapperWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 0 100px;
`;
const Wrapper = styled.div`
  display: flex;
  gap: 50px;
    justify-content: center;
    

  @media screen and (max-width: 1200px) {
    flex-direction: column;
    gap: 0;
  }
  @media screen and (max-width: 600px) {
    margin-top: 115px;
  }
`;
const Container = styled.div`
  margin-top: 50px;
`;
const DetailsText = styled.div`
  padding: 10%;
  // padding-left: 40%;
  // padding-right: 40%;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 1rem;
  font-family: 'Poppins';
  font-weight: 300;
`;
const DetailsPrice = styled.h1`
  text-align: center;
  font-family: 'Poppins';
  font-weight: 300;
`;
const DetailsMiles = styled.h2`
  text-align: center;
  font-family: 'Poppins';
  font-weight: 300;
  font-size: 1.2rem;
`;
const DetailsHeader = styled.h1`
  font-size: 2.5rem;
  font-family: 'Poppins';
  font-weight: 400;
`;
const DetailsContainer = styled.div`
  margin-top: 50px;
  @media screen and (max-width: 768px) {
    margin-top: -75px;
  }
  @media screen and (max-width: 550px) {
    margin-left: 15px;
  }
`;
const DetailsWrapper = styled.div``;
const Socials = styled.div``;
const ValueCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  // border-radius: 10px;
  max-height: 340px;
  margin-right: 15px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
`;
const ValueCard2 = styled.div`
  background: rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  //margin-left: -5px;
  margin-right: 15px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  margin-top: 0px;
  @media screen and (max-width: 500px) {
    margin-top: 50px;
  }
  @media screen and (max-width: 768px) {
    margin-top: 50px;
  }
`;
const SubTitle = styled.div`
  font-size: 1.2rem;
  text-align: center;
`;
const Number = styled.div`
  background: rgba(0, 0, 0, 0.2);
  text-decoration: none;
  outline: none;
  border: 1px solid rgb(178, 12, 78);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;

  padding: 20px;
  font-size: 1.2rem;

  &:hover {
    //transition: all 0.2 ease-in-out;
    background: #fff;
    border: 1px solid rgb(178, 12, 78);
  }
`;
const ContactWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-right: 15px;
`;
const Social = styled.div`
  font-size: 1.8rem;
  text-align: center;
  margin-top: 50px;
`;
const Icons = styled.div`
  text-align: center;
`;
const Paragraph = styled.div`
  font-weight: bold;
  text-align: center;
  padding: 24px;
  margin-top: 25px;
`;
const SliderWrapper = styled.div`
  margin-top: 0%;
  // margin-left: -50px;
`;
const ContactHeader = styled.h1`
  margin-top: 30px;
  font-size: 1.6rem;
`;
const BtnWrap = styled.div`
  max-width: 300px;
  margin-top: 25px;
  margin-bottom: 50px;
`;
const Icon = styled.span`
  &:hover {
    transform: scale(1.05);
  }
`;
const BtnWrapWrap = styled.div`
  display: flex;
  justify-content: center;
`;
const TextWrap = styled.div`
  padding-left: 75px;
  padding-right: 75px;
  @media screen and (max-width: 500px) {
    padding: 0;
  }
`;
const CarDetail = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { carId } = useParams();
  const [car, setCar] = useState(null);
  const [images, setImages] = useState([]);

  async function fetchCar() {
    const docRef = doc(db, 'cars', carId);
    const carDoc = await getDoc(docRef);
    return carDoc.data();
  }

  async function addImagesToCar() {
    await fetchCar().then(async (car) => {
      const imagesRef = collection(db, `cars/${carId}/images`);
      const imageDocs = await getDocs(imagesRef);
      const images = imageDocs.docs.map(doc => ({
        docId: doc.id,
        ...doc.data()
      }));

      const sortedImages = images.slice().sort((a, b) => a.id - b.id);
      setImages(sortedImages);
      setCar({...car, images: sortedImages});
    })
  }
  
  useEffect(() => {
    void addImagesToCar();
  }, [])
  
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? images.length - 1 : (prev) => prev - 1);
  };
  const nextSlide = () => {
    setCurrentSlide(currentSlide === images.length - 1 ? 0 : (prev) => prev + 1);
  };

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1200); // Adjust the breakpoint as needed
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial call

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <Background>
      <Navbar toggle={toggle} />
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <MenuList />
      <WrapperWrapper>
        <Wrapper>
          <Container>
            <SliderWrapper>
              <div className="overflow-hidden flex justify-center align-middle contM">
                <div className=" w-[100vw] h-[450px] relative  boxM">
                  <div
                    style={{
                      transform: `translateX(-${
                        currentSlide * (isSmallScreen ? 100 : 50)
                      }vw)`,
                    }}
                    className="w-[2300vw] h-full flex transition-transform duration-1000 img-boxM"
                  >
                    {images.length !== 0 ?
                      images.map((item, index) => (
                        <img
                          className="w-[100vw] h-[250px] object-cover imgM"
                          src={item.url}
                          alt=""
                          loading="priority"
                        />
                      ))
                      : <div className={"w-[100vw] lg:w-[700px] flex items-center justify-center lg:h-[400px] h-[200px]"}>
                        <ClipLoader size={30} color={'#000'} loading={true} />
                      </div>}
                  </div>
                  <div className="w-full h-full flex align-middle">
                    <div className="absolute w-fit left-[1%] mx-auto flex gap-8 top-[45%] arrowsM">
                      <div
                        onClick={prevSlide}
                        className="w-14 text-white h-14 border-[1px] border-white flex items-center justify-center hover:cursor-pointer hover:bg-black hover:text-white activ:bg-gray-900 duration-300 arrow-left absolute left-0"
                      >
                        <HiArrowLeft />
                      </div>
                    </div>
                    <div className="absolute w-fit right-[1%] mx-auto flex gap-8 top-[45%] arrowsM">
                      <div
                        onClick={nextSlide}
                        className="w-14 h-14 text-white border-[1px] border-white flex items-center justify-center hover:cursor-pointer  hover:bg-black hover:text-white activ:bg-gray-900 duration-300 arrow-right"
                      >
                        <HiArrowRight />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SliderWrapper>
          </Container>
          <DetailsContainer>
            <DetailsWrapper>
              <ValueCard2>
                <DetailsHeader>{car?.title}</DetailsHeader>
                <SubTitle>
                  {car?.spec}
                </SubTitle>
              </ValueCard2>
              <ValueCard>
                <DetailsPrice>
                  Only <strong>£{car?.price.toLocaleString()}</strong>
                </DetailsPrice>
                <DetailsMiles>{car?.miles.toLocaleString()} Miles</DetailsMiles>
              </ValueCard>
              <ContactWrapper>
                <Number>
                  <i className="fa-solid fa-phone"></i>
                  <a href="tel: 0115 9313 131" className="num">
                    {' '}
                    0115 9313 131
                  </a>
                </Number>
                <Number>
                  <i className="fa-solid fa-phone"></i>
                  <a href="tel: 07947 916 916" className="num">
                    {' '}
                    07947 916 916
                  </a>
                </Number>
              </ContactWrapper>
              <Social>View car on our socials:</Social>
              <Icons>
                <Icon>
                  <a
                    href="https://www.facebook.com/MotorsForYouLtd/"
                    className="fa fa-facebook"
                  ></a>
                </Icon>
                <Icon>
                  <a
                    href="https://www.instagram.com/p/C191YvGiOvj/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                    className="fa fa-instagram"
                  ></a>
                </Icon>
              </Icons>
            </DetailsWrapper>
            <Socials></Socials>
          </DetailsContainer>
        </Wrapper>
      </WrapperWrapper>
      <Paragraph>Details you'll want to know:</Paragraph>
      <TextWrap>
        <DetailsText>
          {car?.para1}
        </DetailsText>
        <DetailsText>
          {car?.para2}
        </DetailsText>
        <DetailsText>
          {car?.para3}
        </DetailsText>
        <DetailsText>
          {car?.para4}
        </DetailsText>
        <DetailsText></DetailsText>
      </TextWrap>
      <ContactHeader>Contact us regarding this listing:</ContactHeader>
      <BtnWrapWrap>
        <BtnWrap>
          <Button href="/contact">Contact Us</Button>
        </BtnWrap>
      </BtnWrapWrap>
    </Background>
  );
};

export default CarDetail;
